import React from "react";
import ReactDOM from "react-dom";
import "./style.css";
import App from "./App.tsx";
import { inject } from "@vercel/analytics";
inject();

ReactDOM.render(<App />, document.getElementById("root"));
